import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Paper, Row, Col, IdNumberCheck, //  BorrowerIdCardForm,
BorrowerWorkPlaceTab, BorrowerIncomeTab, BorrowerExternalCreditTab, BorrowerExpenseTab, BorrowerFiles } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AddBorrower = function AddBorrower(_ref) {
  var history = _ref.history;

  var _useState = useState(1),
      _useState2 = _slicedToArray(_useState, 2),
      activeStep = _useState2[0],
      setActiveStep = _useState2[1];

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      borrower = _useState4[0],
      setBorrower = _useState4[1];

  var topRef = useRef();
  useEffect(function () {
    topRef.current.scrollIntoView();
  }, [activeStep]);

  var handleNext = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setActiveStep(function (prev) {
                return prev + 1;
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleNext() {
      return _ref2.apply(this, arguments);
    };
  }();

  var render = function render() {
    switch (activeStep) {
      case 1:
        return ___EmotionJSX(IdNumberCheck, {
          onNext: handleNext,
          onClose: function onClose() {
            return history.push('/borrowers');
          },
          data: borrower,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrower(data);
          }
        });

      case 2:
        return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(BorrowerWorkPlaceTab, {
          margin: "2em 0",
          idNumber: borrower === null || borrower === void 0 ? void 0 : borrower.id_number,
          borrower: borrower,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrower(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                work_place: data
              });
            });
          }
        }), ___EmotionJSX(BorrowerIncomeTab, {
          idNumber: borrower === null || borrower === void 0 ? void 0 : borrower.id_number,
          borrower: borrower,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrower(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                incomes: data
              });
            });
          }
        }), ___EmotionJSX(BorrowerExternalCreditTab, {
          idNumber: borrower === null || borrower === void 0 ? void 0 : borrower.id_number,
          borrower: borrower,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrower(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                external_credits: data
              });
            });
          }
        }), ___EmotionJSX(BorrowerExpenseTab, {
          margin: "0 0 2em 0",
          idNumber: borrower === null || borrower === void 0 ? void 0 : borrower.id_number,
          borrower: borrower,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrower(function (prev) {
              return _objectSpread(_objectSpread({}, prev), {}, {
                expenses: data
              });
            });
          }
        }), ___EmotionJSX(Paper, {
          header: "\u0424\u0430\u0439\u043B\u043E\u0432\u0435",
          margin: "0 0 2em 0"
        }, ___EmotionJSX(BorrowerFiles, {
          borrowerIdNumber: borrower === null || borrower === void 0 ? void 0 : borrower.id_number,
          onNext: function onNext() {
            return history.push('/borrowers');
          }
        })));

      default:
        return ___EmotionJSX(IdNumberCheck, {
          onNext: handleNext,
          data: borrower,
          onBorrowerChange: function onBorrowerChange(data) {
            return setBorrower(data);
          }
        });
    }
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    ref: topRef
  }), ___EmotionJSX(Row, {
    justify: "space-between",
    align: "center",
    backgroundColor: "white",
    padding: "2em",
    className: "container-xxl"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, render())));
};

AddBorrower.propTypes = {
  history: PropTypes.object
};
export default AddBorrower;